import { gql } from '@apollo/client';
import { Box, Text } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { RelativeTime } from '~components/ui/RelativeTime';
import { ScheduleTable_ScheduleFragment } from '../__generated__/ScheduleTable.graphql';

export function CreatedAtCell({
  value,
}: PropsWithChildren<CellProps<ScheduleTable_ScheduleFragment, string>>) {
  return (
    <Box>
      <RelativeTime ts={value} render={(t) => <Text fontSize="sm">{t}</Text>} />
    </Box>
  );
}

CreatedAtCell.graphql = {
  fragments: {
    CreatedAtCell_schedule: gql`
      fragment CreatedAtCell_schedule on Schedule {
        id
        createdAt
      }
    `,
  },
};
